import React from 'react';
import { ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { RiCheckLine, RiEditLine, RiDeleteBinLine, RiMore2Line } from 'react-icons/ri';
import { AdminAgentDealUpdateRequestDto } from '@repo/common-types';

interface AgentDealUpdateRequestQuickActionsProps {
  update: AdminAgentDealUpdateRequestDto;
  onApply: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

/**
 * Agent Deal Update Request Quick Actions Dropdown Component
 * Provides a vertical ellipsis menu with update-specific actions
 */
const AgentDealUpdateRequestQuickActions: React.FC<AgentDealUpdateRequestQuickActionsProps> = ({
  update,
  onApply,
  onEdit,
  onDelete,
}) => {
  const isPending = !update.applied;

  // If the update is already applied, don't show any actions
  if (!isPending) {
    return <span className="text-muted">-</span>;
  }

  return (
    <ButtonGroup>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          type="button"
          aria-label={`More actions for update ${update.id}`}
          className="btn btn-sm d-flex align-items-center justify-content-center"
          style={{ minWidth: '32px', padding: '4px 8px' }}
        >
          <RiMore2Line size={16} />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end" container="body">
          {/* Apply Update */}
          <DropdownItem className="d-flex justify-content-start align-items-center flex-row gap-2" onClick={onApply}>
            <RiCheckLine className="text-success" size={16} />
            Apply Update
          </DropdownItem>

          {/* Edit Update */}
          <DropdownItem className="d-flex justify-content-start align-items-center flex-row gap-2" onClick={onEdit}>
            <RiEditLine className="text-muted" size={16} />
            Edit Update
          </DropdownItem>

          {/* Delete Update */}
          <DropdownItem divider />
          <DropdownItem
            className="d-flex justify-content-start align-items-center text-danger flex-row gap-2"
            onClick={onDelete}
          >
            <RiDeleteBinLine className="text-danger" size={16} />
            Delete Update
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </ButtonGroup>
  );
};

export default AgentDealUpdateRequestQuickActions;
